module.exports = __webpack_public_path__ + "static/peterka-1ffa78463c0eac52ddfc2ea8964862b9.jpg";